import { useOrganizationsQuery } from "@decentriq/graphql/dist/hooks";
import { type OrganizationsQuery } from "@decentriq/graphql/dist/types";
import { useLocalStorageState } from "ahooks";
import { useMemo } from "react";
import { useUserRole } from "hooks";

interface OrganizationSelectorHookResult {
  currentOrganizationId: string | undefined;
  isLoading: boolean;
  organizations: OrganizationsQuery["organizations"]["nodes"];
  selectedOrganizationId: string;
  setSelectedOrganizationId: (organizationId: string) => void;
}

const useOrganizationSelector = (): OrganizationSelectorHookResult => {
  const { organizationId: currentOrganizationId, isLoading } = useUserRole();
  const [selectedOrganizationId, setSelectedOrganizationId] =
    useLocalStorageState<string>("selectedOrganizationId", {
      defaultValue: currentOrganizationId!,
      listenStorageChange: true,
    });
  const { data: organizations } = useOrganizationsQuery();
  const organizationWithDmp = useMemo(
    () =>
      organizations?.organizations.nodes.filter((org) => org.enableDmp) || [],
    [organizations]
  );
  return {
    currentOrganizationId,
    isLoading,
    organizations: organizationWithDmp,
    selectedOrganizationId: selectedOrganizationId!,
    setSelectedOrganizationId,
  };
};

export default useOrganizationSelector;
